import { getSmokerCharts } from "@/api/smoker-charts.service";
export const useSmokerChartSearch = () => {
  const itemTitle = i => i.name;
  return {
    itemTitle,
    comparisonValue: v => v.id,
    fetchResults: async v => {
      const result = await getSmokerCharts({ name: v });
      return result.toSorted((a, b) =>
        a.carrierName.localeCompare(b.carrierName)
      );
    }
  };
};
